var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 12,
    fill: "#B3B3B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.938 15L10.2202 11.2822C9.92685 10.9889 9.92685 10.5133 10.2202 10.22C10.5135 9.92667 10.9891 9.92667 11.2824 10.22L15.0002 13.9378L18.718 10.22C19.0113 9.92667 19.4869 9.92667 19.7802 10.22C20.0735 10.5133 20.0735 10.9889 19.7802 11.2822L16.0624 15L19.7802 18.7178C20.0735 19.0111 20.0735 19.4867 19.7802 19.78C19.4869 20.0733 19.0113 20.0733 18.718 19.78L15.0002 16.0622L11.2824 19.78C10.9891 20.0733 10.5135 20.0733 10.2202 19.78C9.92685 19.4867 9.92685 19.0111 10.2202 18.7178L13.938 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/Attach.bb381a72.svg";
export { ForwardRef as ReactComponent };